export * from './patientDeletedDocumentsQueries';
